// ChatGPT-style "assistant is working" indicator: three cobalt dots bouncing in sequence.
// Used in the vibe-edit chat while a Celery edit is in flight.
export function TypingDots() {
  return (
    <span className="inline-flex items-center gap-1" role="status" aria-label="Applying your change">
      {[0, 150, 300].map((delay) => (
        <span
          key={delay}
          className="h-1.5 w-1.5 rounded-full bg-[#290BD9] animate-bounce"
          style={{ animationDelay: `${delay}ms` }}
        />
      ))}
    </span>
  );
}
